/**
 * Staleness of the live feed. The old dashboard received `lastSeen` and never
 * used it; the new UI shows a banner when the newest Influx point for the
 * open site is older than two minutes (Telegraf writes every 30 s to 1 min).
 */
import { parseLastSeen } from './influxBridge';

export const STALE_AFTER_MS = 2 * 60_000;

export interface Staleness {
  lastSeenMs: number | null;
  /** ms between now and lastSeen; null when the site has no lastSeen. */
  ageMs: number | null;
  /** True when lastSeen is missing or older than STALE_AFTER_MS. */
  stale: boolean;
}

export function computeStaleness(lastSeen: string | null | undefined, nowMs: number, staleAfterMs: number = STALE_AFTER_MS): Staleness {
  const lastSeenMs = parseLastSeen(lastSeen);
  if (lastSeenMs === null) return { lastSeenMs: null, ageMs: null, stale: true };
  const ageMs = Math.max(0, nowMs - lastSeenMs);
  return { lastSeenMs, ageMs, stale: ageMs > staleAfterMs };
}
